<!-- program 主干 详情 -->
<template>
  <div class="mentee-detail">
    <div class="info-large">
      <h1>{{projectDetail.univer}}</h1>
      <!-- <span>2020</span> -->
    </div>
    <div class="info-small">
      <h2>{{projectDetail.overseasName}}</h2>
      <span>Application DDL: {{projectDetail.rolling === 1?'rolling':projectDetail.deadlineTime}}</span>
    </div>
  </div>
</template>

<script>
// api
import { getProjectBasicDetail } from '@/api/project'
import { mapMutations } from 'vuex'
export default {
  name: 'program-main-detail',
  components: {},
  data () {
    return {
      programId: this.$route.params.programId,
      projectDetail: {}
    }
  },
  computed: {},
  mounted () {
    this.getProjectBasicDetail()
  },
  methods: {
    ...mapMutations(['setMenteeDetail']),
    getProjectBasicDetail () {
      getProjectBasicDetail({
        id: this.programId
      }).then(res => {
        this.projectDetail = res.data.model
        this.setMenteeDetail(res.data.model)
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
